import { Link } from 'react-router-dom';
import { reviews } from '@/mocks/comics';

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="lg:w-1/2">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs font-semibold uppercase tracking-wider text-foreground-500">
                  读者评价
                </span>
              </div>
              <blockquote className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-6">
                &ldquo;韩漫之家是我用过最好的韩漫阅读平台&rdquo;
              </blockquote>
              <div className="flex items-center gap-3 mb-8">
                <span className="text-sm font-semibold text-foreground-950">— 来自读者真实反馈</span>
                <span className="flex items-center gap-1 text-accent-500 text-sm">
                  <i className="ri-verified-badge-fill"></i> 已验证
                </span>
              </div>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 text-foreground-700 hover:text-primary-500 font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="lg:w-1/2">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {reviews.slice(0, 4).map((review) => (
                  <div
                    key={review.id}
                    className="bg-background-100 rounded-xl p-5"
                  >
                    <div className="flex items-center gap-1 mb-2">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${
                            i < review.rating
                              ? 'ri-star-fill text-accent-500'
                              : 'ri-star-line text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                      "{review.text}"
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-500">
                      <span className="font-medium text-foreground-950">{review.name}</span>
                      <span>{review.date}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}